import { Button, Intent, MenuItem } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { Select2 } from "@blueprintjs/select";
import _ from "lodash";
import { UserLanguage } from "../../../lang/lang";
import {
  BaseInputProperties,
  FormItemBuilder,
  FormItemBuilderProperties,
  ItemSelectInputProperties,
} from "../Form";
import { ItemRenderer, renderText } from "./helper";

type Bundle = FormItemBuilderProperties<
  any,
  ItemSelectInputProperties<any, any>
>;

const ItemFilter = (bundle: Bundle, query: string, property: any) =>
  renderText(property, bundle).toLowerCase().indexOf(query.toLowerCase()) >= 0;

export const get_intent = (
  bundle: FormItemBuilderProperties<any, BaseInputProperties<any, any>>,
  property: any
) => {
  if (!bundle.field_properties.intent) return Intent.NONE;

  if (typeof bundle.field_properties.intent === "function")
    return bundle.field_properties.intent(property, bundle.field_root_value);

  return bundle.field_properties.intent;
};

export const get_icon = (
  bundle: FormItemBuilderProperties<any, BaseInputProperties<any, any>>,
  property: any
) => {
  if (!bundle.field_properties.icon) return IconNames.CHEVRON_RIGHT;

  if (typeof bundle.field_properties.icon === "function")
    return bundle.field_properties.icon(property, bundle.field_root_value);

  return bundle.field_properties.icon;
};

export const ItemSelectBuilder: FormItemBuilder<
  any,
  ItemSelectInputProperties<any, any>
> = (bundle) => {
  // console.log("select builder", bundle);

  let buttonText = renderText(bundle.field_current_value, bundle);

  if (buttonText.length === 0 && bundle.field_properties.placeholder)
    buttonText = bundle.field_properties.placeholder;

  // console.log("button text", { buttonText });

  const button = (
    <Button
      text={buttonText}
      icon={get_icon(bundle, bundle.field_current_value)}
      alignText="left"
      intent={get_intent(bundle, bundle.field_current_value)}
    />
  );

  return (
    <Select2<any>
      activeItem={bundle.field_current_value}
      itemPredicate={(q, i) => ItemFilter(bundle, q, i)}
      itemRenderer={(property, render_props) =>
        ItemRenderer(bundle, property, render_props)
      }
      items={bundle.field_properties.items || []}
      onItemSelect={(i) => {
        bundle.update_value(i);
      }}
      itemsEqual={(a, b) => {
        if (_.has(a, "id") && _.has(b, "id")) return a.id === b.id;
        else return a === b;
      }}
      noResults={[
        <MenuItem
          key="nothingxd"
          disabled={true}
          text={UserLanguage().errors.no_items}
        />,
      ]}
    >
      {button}
    </Select2>
  );
};
